/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { WebConfiguration as __Configuration } from '../web-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserProfileSummary } from '../models/user-profile-summary';

/**
 * All about the user login
 */
@Injectable({
  providedIn: 'root',
})
class LoginService extends __BaseService {
  static readonly loginPath = '/login';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * login user
   * @return Success
   */
  loginResponse(): __Observable<__StrictHttpResponse<UserProfileSummary>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserProfileSummary>;
      })
    );
  }
  /**
   * login user
   * @return Success
   */
  login(): __Observable<UserProfileSummary> {
    return this.loginResponse().pipe(
      __map(_r => _r.body as UserProfileSummary)
    );
  }
}

namespace LoginService {
}

export { LoginService }
